export default __webpack_public_path__ + "images/logo.svg?bbdc3fb7d6980cc53f58b119807f3c3e";